import { api } from './../../system/api';

export default {
    delivering: id => api.put(`delivery-requests/${id}/delivering`)
};
